import { jsx as _jsx } from "react/jsx-runtime";
export function Title(props) {
    return _jsx("h1", { children: props.children });
}
export function Small(props) {
    return _jsx("small", { children: props.children });
}
export function Bold(props) {
    return _jsx("b", { children: props.children });
}
export function Italic(props) {
    return _jsx("i", { children: props.children });
}
export function Underline(props) {
    return _jsx("u", { children: props.children });
}
